@if (!isEdit) {
  <h2 mat-dialog-title>Add Geologist</h2>
} @else {
  <h2 mat-dialog-title>Edit Geologist</h2>
}

<mat-dialog-content>
  <form id="link-form" [formGroup]="geologistForm" (ngSubmit)="submit()">
    <p>
      <mat-form-field appearance="outline">
        <mat-label>Name</mat-label>
        <mat-select [formControl]="name">
          @for (geologist of geologistList; track geologist) {
            <mat-option value="{{ geologist }}">{{ geologist }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </p>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button type="submit" form="link-form" [disabled]="!geologistForm.valid">
    Save
  </button>
  <button mat-button type="button" (click)="onCancel()">Cancel</button>
</mat-dialog-actions>
